module.exports = __webpack_public_path__ + "img/suit-08.072fe175.png";